export function InvoiceItemsCtrl ($scope, $state, $translate, workshopAPI) {

  $scope.tableSettings = {
    columns: [
      {
        field : 'item_code',
        header: {
          text: $translate.instant('PRODUCT_SPACE.PRODUCT')
        },
        classes: 'Uppercase'
      },
      {
        field : 'description',
        header: {
          text: $translate.instant('GENERAL_SPACE.FIELD.DESCRIPTION')
        }
      },
      {
        field : 'hours_worked',
        header: {
          text: $translate.instant('VEHICLE_SPACE.HOURS')
        }
      }
    ],
    empty: {
      text: $translate.instant('QUERY_DROPDOWN_SPACE.GRID.NO_ITEMS_FOUND')
    },
    pagination: {
      enabled   : true,
      pageSize  : 5,
      pageSizes : [ 5, 10, 25, 50 ],
      queryCount: () => workshopAPI.get('/invoices/invoice_item_count', [
        $scope.invoice.id,
        'J'
      ])
    },
    rows: {
      highlight: {
        enabled: true
      }
    },
    sorting: {
      direction: 'asc',
      enabled  : true,
      field    : 'item_code'
    },
  };

  $scope.getInvoiceItems = ( params ) => {
    return workshopAPI.get('/invoices/invoice_item_list', [
      $scope.invoice.id,
      params.offset,
      params.pageSize,
      'J',
      params.field,
      params.direction
    ]).then(function (items) {
      $scope.invoice_items = items;
      return items;
    });
  };

  $scope.onRowClick = function (event) {
    $state.go('app.labor-items', {
      invoice_id     : event.row.invoice_id,
      invoice_item_id: event.row.id
    });
  };

  $scope.getInvoiceItems({
    offset: 0,
    pageSize: 5,
    field: 'item_code',
    direction: 'asc'
  });
}